import { Text, TextProps } from '@wix/design-system';
import React, { FC } from 'react';
import { ScrollLink } from 'react-scroll';

type ScrollLinkProps = React.ComponentProps<typeof ScrollLink>;

interface Props
  extends Omit<TextProps, 'children' | 'onClick'>,
    ScrollLinkProps {
  href: string;
  className: string;
  children: React.ReactNode;
  onClick?: () => void;
}

const LinkWithHref: FC<Props> = (props) => {
  return (
    <Text
      skin={props.className?.indexOf('active') > -1 ? 'primary' : 'standard'}
      {...props}
      size={props.size || 'small'}
      tagName="a"
      href={props.href}
      className={props.className}
    >
      {props.children}
    </Text>
  );
};

export default ScrollLink(LinkWithHref);
